import { CoreButton } from '@components'
import ArrowIcon from '@images/icons/arrow-icon-white.svg?react'
import WarningIcon from '@images/icons/warning-icon-orange.svg?react'
import { paths, usePendingApprovalsCount } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { useHistory } from 'react-router-dom'

import './TransactionsRequiringApproval.scss'

interface Props {
  className?: string
}

function TransactionsRequiringApproval({ className }: Props) {
  const history = useHistory()

  const { toApprove, notApproved } = usePendingApprovalsCount()

  if (toApprove === 0 && notApproved === 0) {
    return null
  }

  const handleReviewClick = () => {
    history.push(paths.banking.transactions.list() + '?tab=pending-approvals')
  }

  return (
    <div className={`transactions-requiring-approval ${className}`}>
      <div className='content'>
        <div className='icon'>
          <WarningIcon />
        </div>
        <div className='text'>
          {toApprove > 0 && (
            <div className='approval-block'>
              <h3 className='title'>
                {tr('FRONTEND.DASHBOARD.TRANSACTIONS.REQUIRES_APPROVAL.TITLE', 'Requires Approval')} ({toApprove})
              </h3>
              <p className='description'>
                {tr(
                  'FRONTEND.DASHBOARD.TRANSACTIONS.REQUIRES_APPROVAL.DESCRIPTION',
                  'Transactions are awaiting your approval.'
                )}
              </p>
            </div>
          )}
          {toApprove === 0 && notApproved > 0 && (
            <div className='approval-block'>
              <h3 className='title'>
                {tr('FRONTEND.DASHBOARD.TRANSACTIONS.AWAITING_APPROVAL.TITLE', 'Awaiting Approval')} ({notApproved})
              </h3>
              <p className='description'>
                {tr(
                  'FRONTEND.DASHBOARD.TRANSACTIONS.AWAITING_APPROVAL.DESCRIPTION',
                  'Your transactions are pending approval.'
                )}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className='action'>
        <CoreButton
          text={tr('PORTAL.IBAN_REQUEST.STEP_REVIEW', 'Review')}
          variation='primary-black'
          size='normal'
          onClick={handleReviewClick}
          RightIcon={<ArrowIcon />}
        />
      </div>
    </div>
  )
}

export default TransactionsRequiringApproval
